import { put, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import PATHS from '../../../constants/paths';

import { getType } from 'typesafe-actions';
import { authResetPasswordSuccess, authSignInSuccess, authSignUpSuccess } from '../actions';
import { clickUserProfileLogout } from '../../UserProfile/actions';

function* handleAuthRedirectsSaga() {
  yield put(push(PATHS.HOME));
}

function* handleSignedOutRedirect() {
  yield put(push(PATHS.AUTH.SIGN_IN));
}

export default function* authRedirectsSaga() {
  yield takeEvery([getType(authSignUpSuccess), getType(authSignInSuccess)], handleAuthRedirectsSaga);
  yield takeEvery([getType(authResetPasswordSuccess), getType(clickUserProfileLogout)], handleSignedOutRedirect);
}



// WEBPACK FOOTER //
// ./src/containers/Auth/saga/authRedirectsSaga.ts